import { ReactNode, useEffect } from 'react';

import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import CalculatorForm from '~components/EstimatedCalculator/CalculatorForm';
import UnauthenticatedLayout from '~components/ui/layout/UnauthenticatedLayout';
import { mixpanel } from '~pages/_app';

export default function EstimatedCalculator() {
  const router = useRouter();

  useEffect(() => {
    mixpanel.track('View landing - calculator', {
      utm_source: router.query.utm_source,
    });
  }, []);

  return (
    <UnauthenticatedLayout>
      <div
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        <SubTitle>CALCULATOR</SubTitle>
        <Title>예상 한도를 확인해보세요</Title>
        <CalculatorForm />
      </div>
    </UnauthenticatedLayout>
  );
}

const SubTitle = styled.p`
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 130%;
  letter-spacing: 4.8px;
  text-transform: uppercase;
  background: linear-gradient(90deg, #bec5fb, #4ec9c3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 500px) {
    font-size: 13px;
    letter-spacing: 3.9px;
  }
`;
const Title = styled.h1`
  text-align: center;
  margin: 24px auto 0;

  font-size: 64px;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: -1.92px;

  @media (max-width: 500px) {
    font-size: 32px;
    letter-spacing: -0.96px;
    width: 200px;
  }
`;

EstimatedCalculator.getLayout = (node: ReactNode) => node;
